import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const BlogSearch = ({ onSearch, onCategoryFilter, selectedCategory, categories }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    onSearch(value);
  };

  const handleCategoryClick = (categoryId) => {
    onCategoryFilter(categoryId);
  };

  return (
    <section className="bg-background pt-12 pb-8 border-b border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Search Bar */}
          <div className="relative mb-8">
            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
              <Icon name="Search" size={20} className="text-text-muted" />
            </div>
            <Input
              type="search"
              placeholder="Search articles by title, topic, or keyword..."
              value={searchTerm}
              onChange={handleSearchChange}
              className="pl-12 pr-4 py-4 w-full text-lg bg-white/5 border-2 border-white/10 focus:border-accent rounded-xl text-text-primary placeholder:text-text-muted"
            />
          </div>

          {/* Category Filters */}
          <div className="flex flex-wrap gap-3 justify-center">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => handleCategoryClick(category.id)}
                className={`px-4 py-2 rounded-full font-body font-medium text-sm transition-smooth ${
                  selectedCategory === category.id
                    ? 'bg-accent text-white shadow-lg'
                    : 'bg-white/5 hover:bg-white/10 text-text-secondary hover:text-text-primary border border-white/10'
                }`}
              >
                {category.name}
                <span className="ml-2 text-xs opacity-75">({category.count})</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogSearch;